import { render } from "./amountBreakup.vue?vue&type=template&id=6bdf84a8"
import script from "./amountBreakup.vue?vue&type=script&lang=js"
export * from "./amountBreakup.vue?vue&type=script&lang=js"

import "./amountBreakup.vue?vue&type=style&index=0&id=6bdf84a8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__